// Generated by build.mjs — do not edit by hand.
export const GIT_BRANCH = 'main';
